import * as firebase from "firebase/app";
import "firebase/auth";
// const app = firebase.initializeApp({
//   apiKey: "AIzaSyBYN2jiPFBKhPsoQRoGDWcCOVgNy91ZgTM",
//   authDomain: "lucky7-4ccbe.firebaseapp.com",
//   databaseURL: "https://lucky7-4ccbe.firebaseio.com",
//   projectId: "lucky7-4ccbe",
//   storageBucket: "lucky7-4ccbe.appspot.com",
//   messagingSenderId: "1026000176974",
//   appId: "1:1026000176974:web:0a70c83cbcdbb0fa56c01f",
//   measurementId: "G-D8RLE55BZG",
// });
//Igor
const app = firebase.initializeApp({
  apiKey: "AIzaSyA6kUhKc8cJQm8za9GKk1RWU18K9TRCeqc",
  authDomain: "www.lucky7.games",
  databaseURL: "https://lucky7-engine.firebaseio.com",
  projectId: "lucky7-engine",
  storageBucket: "lucky7-engine.appspot.com",
  messagingSenderId: "740700148933",
  appId: "1:740700148933:web:6e420f2b85d007e64dccac",
  measurementId: "G-KYSM9GW1ZD",
});

export default app;
